<template>
  <!-- 企业荣誉 -->
  <div class="honor_wrap">
    <div class="honor_wrap_inner">
      <div class="title_wrap">
        {{ honorData.title }}
      </div>
      <div class="content_wrap">
        <div class="para_box">
          <div class="para_box_item" v-for=" item in honorData.paraArr" :key=" item.id">
            {{ item.text }}
          </div>
        </div>
        <div class="img_box">
          <div class="img_box_item" v-for=" imgItem in honorData.imgArr" :key=" imgItem.id">
            <img  :src="imgItem.imgUrl" :alt="imgItem.alt" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import honorLocalStoreData from '@/assets/mediaList/about.json'
  export default {
    data() {
      return {
        honorData: honorLocalStoreData.honor
      }
    }
  }
</script>

<style scoped lang="scss">
  .honor_wrap {
    width: 100%;
    min-height: 300px;
    margin: 0;
    padding: 4% 0 8% 0;
    .honor_wrap_inner {
      width: 94%;
      max-width: 1280px;
      min-width: 0;
      padding: 0;
      margin: 0 auto;
    }
  }
  .title_wrap {
    width: auto;
    margin: 0 auto;
    padding: 0 0 2% 0;
    line-height: normal;
    font-size: 24px;
    text-align: center;
    font-weight: normal;
  }
  .content_wrap {
    margin: 0;
    line-height: 2.5;
    color: rgba(102,102,102,1);
    font-size: 16px;
    .para_box_item {
      text-indent: 2em;
    }
    .img_box {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
      gap: 20px;
      width: 100%;
      height: auto;
      img {
        display: block;
        width: 100%;
        max-width: 100%;
        height: auto;
      }
    }
  }
</style>
